@if (!self?.changeMarker) { @switch (headerLevel()) { @default {
<h1 [ngClass]="{ tailored: self?.tailored }" [attr.title]="showTitle ? self?.label : null">
	{{ self?.label }}
</h1>
} @case (2) {
<h2 [ngClass]="{ tailored: self?.tailored }" [attr.title]="showTitle ? self?.label : null">
	{{ self?.label }}
</h2>
} @case (3) {
<h3 [ngClass]="{ tailored: self?.tailored }" [attr.title]="showTitle ? self?.label : null">
	{{ self?.label }}
</h3>
} @case (4) {
<h4 [ngClass]="{ tailored: self?.tailored }" [attr.title]="showTitle ? self?.label : null">
	{{ self?.label }}
</h4>
} @case (5) {
<h5 [ngClass]="{ tailored: self?.tailored }" [attr.title]="showTitle ? self?.label : null">
	{{ self?.label }}
</h5>
} @case (6) {
<h6 [ngClass]="{ tailored: self?.tailored }" [attr.title]="showTitle ? self?.label : null">{{ self?.label }}</h6>
} } } @else { @switch (headerLevel()) { @default {
<h1
	[ngClass]="{ tailored: self?.tailored }"
	[innerHTML]="(self?.changeMarker)!.label"
	[attr.title]="showTitle ? self?.label : null"
></h1>
} @case (2) {
<h2
	[ngClass]="{ tailored: self?.tailored }"
	[innerHTML]="(self?.changeMarker)!.label"
	[attr.title]="showTitle ? self?.label : null"
></h2>
} @case (3) {
<h3
	[ngClass]="{ tailored: self?.tailored }"
	[innerHTML]="(self?.changeMarker)!.label"
	[attr.title]="showTitle ? self?.label : null"
></h3>
} @case (4) {
<h4
	[ngClass]="{ tailored: self?.tailored }"
	[innerHTML]="(self?.changeMarker)!.label"
	[attr.title]="showTitle ? self?.label : null"
></h4>
} @case (5) {
<h5
	[ngClass]="{ tailored: self?.tailored }"
	[innerHTML]="(self?.changeMarker)!.label"
	[attr.title]="showTitle ? self?.label : null"
></h5>
} @case (6) {
<h6
	[ngClass]="{ tailored: self?.tailored }"
	[innerHTML]="(self?.changeMarker)!.label"
	[attr.title]="showTitle ? self?.label : null"
></h6>
} } }
